import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'has_the_fac_taken_steps_to_enable_wrkrs_w_hivaids_to_retain_the'

export const dataPointDefinition = {
  retracedId: 'has_the_fac_taken_steps_to_enable_wrkrs_w_hivaids_to_retain_the',
  name: 'Has the facility taken steps to enable workers with HIV/AIDS to retain their work if they were medically able to?',
  description: 'Answer Not Applicable means that in the assessment period no workers were affected by HIV / AIDS.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'ynna',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'ynna',
    },
    {
      name: 'Not Applicable',
      key: 'NOT_APPLICABLE',
      slcpIndex: 3,
      slcpOptionName: 'ynna',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NOT_APPLICABLE'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wt-dis-36',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 11490,
  sectionId: '2.2.5',
  impactArea: 'Discrimination, Violence or Harassment',
  impactAreaId: 'DISCRIMINATION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
